export const POST_HOMEMESSAGE_RETURN = 'POST_HOMEMESSAGE_RETURN';
export const POST_HOMEMESSAGE_SAGAS = 'POST_HOMEMESSAGE_SAGAS';

export const GET_HOMEMESSAGES_RETURN = 'GET_HOMEMESSAGES_RETURN';
export const GET_HOMEMESSAGES_SAGAS = 'GET_HOMEMESSAGES_SAGAS';

export const PUT_HOMEMESSAGE_RETURN = 'PUT_HOMEMESSAGE_RETURN';
export const PUT_HOMEMESSAGE_SAGAS = 'PUT_HOMEMESSAGE_SAGAS';

export const PUT_HOMEMESSAGES_ORDRE_RETURN = 'PUT_HOMEMESSAGES_ORDRE_RETURN';
export const PUT_HOMEMESSAGES_ORDRE_SAGAS = 'PUT_HOMEMESSAGES_ORDRE_SAGAS';

export const DEL_HOMEMESSAGE_RETURN = 'DEL_HOMEMESSAGE_RETURN';
export const DEL_HOMEMESSAGE_SAGAS = 'DEL_HOMEMESSAGE_SAGAS';

export const GET_HOMESETTINGS_RETURN = 'GET_HOMESETTINGS_RETURN';
export const GET_HOMESETTINGS_SAGAS = 'GET_HOMESETTINGS_SAGAS';

export const PUT_HOMESETTINGS_RETURN = 'PUT_HOMESETTINGS_RETURN';
export const PUT_HOMESETTINGS_SAGAS = 'PUT_HOMESETTINGS_SAGAS';

// POST HOMEMESSAGE
export const postHomemessageSagas = (xAccess, data) => ({
	type: POST_HOMEMESSAGE_SAGAS,
	token: xAccess,
	data: data
});
export const postHomemessageReturn = (result) => ({
	type: POST_HOMEMESSAGE_RETURN,
	payload: result
});

// GET HOMEMESSAGES
export const getHomemessagesSagas = (xAccess) => ({
	type: GET_HOMEMESSAGES_SAGAS,
	token: xAccess
});
export const getHomemessagesReturn = (result) => ({
	type: GET_HOMEMESSAGES_RETURN,
	payload: result
});

// PUT HOMEMESSAGE
export const putHomemessageSagas = (uuid, xAccess, data) => ({
	type: PUT_HOMEMESSAGE_SAGAS,
	token: xAccess,
	payload: uuid,
	data: data
});
export const putHomemessageReturn = (result) => ({
	type: PUT_HOMEMESSAGE_RETURN,
	payload: result
});

// PUT HOMEMESSAGES ORDRE
export const putHomemessagesOrdreSagas = (xAccess, ordreList) => ({
	type: PUT_HOMEMESSAGES_ORDRE_SAGAS,
	token: xAccess,
	data: ordreList
});
export const putHomemessagesOrdreReturn = (result) => ({
	type: PUT_HOMEMESSAGES_ORDRE_RETURN,
	payload: result
});

// DELETE HOMEMESSAGE
export const deleteHomemessageSagas = (uuid, xAccess) => ({
	type: DEL_HOMEMESSAGE_SAGAS,
	token: xAccess,
	payload: uuid
});
export const deleteHomemessageReturn = (result) => ({
	type: DEL_HOMEMESSAGE_RETURN,
	payload: result
});

// GET HOMESETTINGS
export const getHomesettingsSagas = (xAccess) => ({
	type: GET_HOMESETTINGS_SAGAS,
	token: xAccess
});
export const getHomesettingsReturn = (result) => ({
	type: GET_HOMESETTINGS_RETURN,
	payload: result
});

// PUT HOMESETTINGS
export const putHomesettingsSagas = (xAccess, data) => ({
	type: PUT_HOMESETTINGS_SAGAS,
	token: xAccess,
	data: data
});
export const putHomesettingsReturn = (result) => ({
	type: PUT_HOMESETTINGS_RETURN,
	payload: result
});
